export const street = (value) => {
  return /^([\p{L}\d.,\-' /]*)$/u.test(value)
}

export const zipCode = (value) => {
  return /^([a-zA-Z\d][a-zA-Z\- \d]*[a-zA-Z\- \d])$/.test(value)
}

export const city = (value) => {
  return /^([\p{L}.\-'?! ]*)$/u.test(value)
}

export const company = (value) => {
  return /^([\p{L}\d.,\-'?! ]*)$/u.test(value)
}

export const mustStartEndLetter = (value) => {
  return /^[\p{L}].+[\p{L}]$/u.test(value)
}

export const mustStartEndLetterNumber = (value) => {
  return /^([\p{L}\d /]{2,})*$/u.test(value)
}

export const person = (value) => {
  return /^([\p{L}.\-' ]*)$/u.test(value)
}

export const phone = (value) => {
  return /^([+\d][\d]*[\d])$/.test(value)
}

export const reference = (value) => {
  return /^([a-zA-Z_\-\d][a-zA-Z_\-\d]*[a-zA-Z_\-\d])$/.test(value)
}
